module.exports = __webpack_public_path__ + "static/media/broed-b.57c67f46.mp3";